import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { Brikk } from 'components/Brikk';
import { SearchInput } from 'components/form-elements/inputs/SearchInput';
import { Text } from 'components/typography';
import { PageLoader } from 'components/loaders/PageLoader';
import { useGetGroups } from 'services/2n/groups';
import { useModal } from 'store/modals';
import { useAccessManagement2NModal } from '../AccessManagement2NModalContext/useAccessManagement2NModal';
import { ManualScrollToTop } from '../../../../../../../ManualScrollToTop';
import { Group } from './components/Group';
import styles from './styles.module.scss';

export const Groups = () => {
  
  const groupsListRef = React.useRef(null);
  const modal = useModal();
  const [keyword, setKeyword] = useState('');
  const { groups, isLoading } = useGetGroups();
  const intl = useIntl();
  const accessManagement2NModal = useAccessManagement2NModal();
  // const sortedGroups = groups.sort(
  //   (a, b) => -b.name.localeCompare(a.name),
  // );

  const filteredGroups = !keyword ? groups : groups.filter(
    group => (group.Name).toLowerCase().includes(keyword.toLowerCase()),
  );
  return (
    <div className={styles.groupContainer}>
      <Brikk.Heading
        heading="accessGroupsTitle"
      />
      <div 
        className={styles.groupList}
        ref={groupsListRef}
      >
        <SearchInput
          placeholder={intl.formatMessage({ id: 'search' })}
          keyword={keyword}
          setKeyword={setKeyword}
        />

        {isLoading && <PageLoader />}
        {!isLoading && filteredGroups && filteredGroups.length > 0 && (
          filteredGroups.map((group, index) => (
            <Group
              key={index}
              group={group}
            />
          ))
        )}
        {!isLoading && (!filteredGroups || filteredGroups.length === 0) && (
          <Text
            secondary
            center
            intl="noGroupsToDisplay"
            size={16}
          />
        )}
      </div>

      <ManualScrollToTop elementRef={groupsListRef} />

      <div className={styles.formActions}>
        <div className={styles.actionContainer}>

          <Button
            primary
            disabled={accessManagement2NModal.isAdding.group}
            onClick={() => {
              if (accessManagement2NModal.hasUnsavedChanges.group) {
                modal.openModal({
                  modalType: 'ConfirmationModal',
                  modalProps: {
                    type: 'error',
                    title: intl.formatMessage({
                      id: 'unsavedChanges',
                    }),
                    content: intl.formatMessage({
                      id: 'unsavedChangesDescription',
                    }),
                    confirmLabel: intl.formatMessage({
                      id: 'discard',
                    }),
                    cancelLabel: intl.formatMessage({
                      id: 'stay',
                    }),
                    onConfirm: () => {
                      modal.closeModal();
                      accessManagement2NModal.setHasUnsavedChanges('group', false);
                      accessManagement2NModal.updateSelected('group', null);
                      accessManagement2NModal.updateAdding('group', true);
                    },
                  },
                });
              } else {
                accessManagement2NModal.updateSelected('group', null);
                accessManagement2NModal.updateAdding('group', true);
              }
            }}
          >
            {intl.formatMessage({ id: 'addNewGroup' })}
          </Button>
        </div>
      </div>
    </div>
  );
};
